exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.input-box-wrapper[data-v-5eb1787c] {\n  position: relative;\n}\n", ""]);

